import { useEffect, useRef } from "react";

const contactCards = [
  { icon: "ri-phone-fill", title: "Phone", lines: ["+91 99451 24133", "080 27822444"], action: { label: "Call Now", href: "tel:+919945124133" } },
  { icon: "ri-whatsapp-fill", title: "WhatsApp", lines: ["+91 99451 24133", "Quick replies during working hours"], action: { label: "Chat Now", href: "https://wa.me/919945124133" } },
  { icon: "ri-mail-fill", title: "Email", lines: ["sales@urbaninfraproject.in"], action: { label: "Send Email", href: "mailto:sales@urbaninfraproject.in" } },
  { icon: "ri-map-pin-fill", title: "Office Address", lines: ["#2, CNR Complex, First Floor", "Muthanallur Cross, Sarjapur Main Road, Bangalore – 562125"], action: { label: "Get Directions", href: "https://maps.app.goo.gl/Nw8RvpZjMwLjBbhh8?g_st=ic" } },
  { icon: "ri-time-fill", title: "Working Hours", lines: ["Monday – Saturday: 11:00 AM – 7:00 PM", "Sunday: By Appointment Only"], action: null },
  { icon: "ri-building-2-fill", title: "Location", lines: ["Bengaluru, Karnataka", "Sarjapur Road Corridor"], action: null },
];

export default function ContactInfoCards() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const cards = ref.current?.querySelectorAll(".info-card");
          cards?.forEach((card, i) => {
            setTimeout(() => {
              card.classList.add("opacity-100", "translate-y-0");
              card.classList.remove("opacity-0", "translate-y-6");
            }, i * 80);
          });
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-14 md:py-16 bg-[#EAF5E1]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-white text-[#7FBF3F] text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider border border-[#7FBF3F]/20">
            <i className="ri-contacts-line"></i>Contact Information
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#212121]" style={{ fontFamily: "'Playfair Display', serif" }}>
            Reach Us Anytime
          </h2>
        </div>

        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {contactCards.map((card) => (
            <div key={card.title} className="info-card opacity-0 translate-y-6 transition-all duration-500 bg-white rounded-xl p-6 border border-[#7FBF3F]/10 hover:border-[#7FBF3F]/30 hover:-translate-y-1 group">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#EAF5E1] rounded-xl flex-shrink-0">
                  <i className={`${card.icon} text-xl text-[#7FBF3F]`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-[#212121] text-sm mb-2">{card.title}</h3>
                  {card.lines.map((line, i) => (
                    <p key={i} className={`text-sm leading-relaxed ${i === 0 ? "text-gray-800 font-medium" : "text-gray-500"}`}>{line}</p>
                  ))}
                  {card.action && (
                    <a
                      href={card.action.href}
                      target={card.action.href.startsWith("http") ? "_blank" : undefined}
                      rel={card.action.href.startsWith("http") ? "nofollow noreferrer" : undefined}
                      className="inline-flex items-center gap-1.5 text-[#7FBF3F] text-xs font-semibold mt-3 hover:underline cursor-pointer whitespace-nowrap"
                    >
                      {card.action.label}<i className="ri-arrow-right-line text-xs"></i>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
